import { useSelector } from 'react-redux';
import { selectEffectivePlatformPermissions, selectPlatformPermissionsStatus } from './platformPermissionsSlice';
import type { PlatformAccessLevel } from './platformAccessLevel';
import { hasPlatformEdit, hasPlatformVisibility } from './platformAccessLevel';

export function usePlatformAccessLevel(permissionKey: string) {
  const effective = useSelector(selectEffectivePlatformPermissions);
  const status = useSelector(selectPlatformPermissionsStatus);
  const ready = status === 'succeeded' && effective !== null;
  const level = (effective?.[permissionKey] as PlatformAccessLevel | undefined) ?? 'none';

  // Mientras cargan permisos no bloquear UI (comportamiento previo); con datos reales aplicar niveles.
  const canView = !ready || hasPlatformVisibility(level);
  const canEdit = !ready || hasPlatformEdit(level);

  return {
    level,
    status,
    ready,
    canView,
    canEdit,
  };
}
